import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/jukeTreasureApi'

class Store {
  @observable list = []
  @action
  getList = async () => {
    let {
      data: { list }
    } = await Api.example_list()
    runInAction(() => {
      this.list = list
    })
  }

  @observable content = {}
  @action
  getDetails = id => async () => {
    let { data } = await Api.example_detail({ finder_activity_id: id })
    runInAction(() => {
      this.content = data
    })
  }
}
export default new Store()
